import type { Schema } from "../../../core/render/logic/Markdoc/index";

export const strong: Schema = {
	render: "strong",
};
